import gql from 'graphql-tag';

export const BACKWARD_NUMBER_QUERY = gql`
  query NumberInBackward($date: ISO8601DateTime!) {
    detectNumberBackward(date: $date)
  }
`;

export const BILLING_QUERY = gql`
  query Billing {
    billing {
      id
      nazev
      ic
      dic
      mesto
      ulice
      psc
      stat
    }
  }
`;

export const CHECK_PATTERN_QUERY = gql`
  query CheckPattern($number: String!, $date: ISO8601DateTime) {
    checkPattern(number: $number, date: $date)
  }
`;

export const COMPANY_LOOKUP_QUERY = gql`
  query CompanyInfo($companyNumber: String!, $site: String!){
    companyLookup(companyNumber: $companyNumber, site: $site) {
      name
      countryCode
      addressStreet
      addressCity
      addressPostcode
      vatNo
      regNo
      taxNo
      phone
      email
      mobile
      bankAccount
      web
    }
  }
`;

export const CONTACTS_QUERY = gql`
  query Contacts($page: Int, $perPage: Int, $fulltext: String, $attribute: String, $direction: String) {
    contacts(
      paginate: { page: $page, perPage: $perPage }
      filter: { fulltext: $fulltext }
      sort: { attribute: $attribute, direction: $direction }
    ) {
      collection {
        id,
        city
        companyNumber
        countryCode
        email
        expensesCount
        invoicesCount
        name
        phone
        postcode
        street
        subdivision
        subscriptionId
        taxNumber
        vatNumber
        web
      }
      metadata {
        totalPages
        currentPage
        totalCount
      }
    }
  }
`;

export const CONTACT_QUERY = gql`
  query Contact($id: ID!) {
    contact(id: $id) {
      id
    }
  }
`;

export const COUNTRIES_QUERY = gql`
  query Countries {
    countries {
      key
      value
      subdivisions
    }
  }
`;

export const COUNTRY_SUBDIVISIONS_QUERY = gql`
  query CountrySubdivision($country: String!) {
    countrySubdivisions(country: $country) {
      key
      value
    }
  }
`;

export const EVENTS_QUERY = gql`
  query Events($kinds: [LogKindEnum!]!, $invoiceId: ID, $logsPage: Int, $logsPerPage: Int) {
    events(filter:{ kinds: $kinds }, invoiceId: $invoiceId, paginate: { perPage: $logsPerPage, page: $logsPage }) {
      collection {
        id
        createdAt
        action
        actorEmail
        actorType
        recordType
        recordId
        recordNumber
        recordName
        payload
        isSystemEvent
      }
      metadata {
        limitValue
        totalPages
        currentPage
        totalCount
      }
    }
  }
`;

export const EXPENSES_QUERY = gql`
  query Expenses($page: Int, $perPage: Int, $fulltext: String, $attribute: String, $direction: String, $period: String, $contactId: Int, $from: String, $to: String, $states: [ExpenseStateEnum!], $dueFrom: String, $dueTo: String, $amountFrom: Int, $amountTo: Int) {
    expenses(
      paginate: { page: $page, perPage: $perPage }
      filter: { fulltext: $fulltext, contactId: $contactId, period: $period, from: $from, to: $to, states: $states, dueFrom: $dueFrom, dueTo: $dueTo, amountFrom: $amountFrom, amountTo: $amountTo }
      sort: { attribute: $attribute, direction: $direction }
    ) {
      collection {
        id
        currency
        dueOn
        issuedOn
        notes
        number
        paid
        paidAt
        state
        taxAmount
        totalAmount
        amountWithoutTax
        attachment {
          url
          name
        }
        contact {
          id
          name
        }
      }
      metadata {
        limitValue
        totalPages
        currentPage
        totalCount
      }
    }
  }
`;

export const EXPENSES_REPORT_QUERY = gql`
  query ExpenseReport($fulltext: String, $contactId: Int, $period: String, $from: String, $to: String, $states: [ExpenseStateEnum!], $dueFrom: String, $dueTo: String, $amountFrom: Int, $amountTo: Int) {
    expensesReport(
      filter: {fulltext: $fulltext, contactId: $contactId, period: $period, from: $from, to: $to, states: $states, dueFrom: $dueFrom, dueTo: $dueTo, amountFrom: $amountFrom, amountTo: $amountTo}
    ) {
      baseCurrency
      from
      paidCount
      paidSum
      expensesSum
      expensesCount
      overdueCount
      overdueSum
      unpaidSum
      unpaidCount
      to
    }
  }
`;

export const EXPENSE_QUERY = gql`
  query Expense($id: ID, $clone: Boolean) {
    expense(id: $id, clone: $clone) {
      id
      issuedOn
      dueOn
      number
      notes
      hasVat
      contactId
      currency
      taxAmount
      totalAmount
      attachment {
        url
        name
      }
    }
  }
`;

export const EXTRACT_SEQUENCE_QUERY = gql`
  query ExtractSequence($sequence: String!, $date: ISO8601DateTime) {
    extractSequence(sequence: $sequence, date: $date) {
      number,
      pattern
    }
  }
`;

export const GEO_INFO_QUERY = gql`
  query GeoIP {
    ipInfo {
      countryCode
      currencyCode
      language
    }
  }
`;

export const INVOICES_BATCH_DOWNLOAD_STATUS_QUERY = gql`
  query invoicesBatchDownloadStatus($jobId:String!) {
    invoicesBatchDownloadStatus(jobId: $jobId) {
      result
      status
    }
  }
`;

export const INVOICES_BY_IDS_QUERY = gql`
  query InvoicesByIds($ids: [ID!]!) {
    invoicesByIds(ids: $ids) {
      id
      state
      number
      paid
      paidAt
    }
  }
`;

export const INVOICES_QUERY = gql`
  query Invoices($page: Int, $perPage: Int, $fulltext: String, $attribute: String, $direction: String, $unpaid: Boolean, $contactId: Int, $period: String, $from: String, $to: String, $invoiceKinds: [String!], $recurring: Boolean, $states: [InvoiceStateEnum!], $dueFrom: String, $dueTo: String, $amountFrom: Int, $amountTo: Int) {
    invoices(
      paginate: { page: $page, perPage: $perPage }
      filter: { fulltext: $fulltext, unpaid: $unpaid, contactId: $contactId, period: $period, from: $from, to: $to, invoiceKinds: $invoiceKinds, recurring: $recurring, states: $states, dueFrom: $dueFrom, dueTo: $dueTo, amountFrom: $amountFrom, amountTo: $amountTo }
      sort: { attribute: $attribute, direction: $direction }
    ) {
      collection {
        id
        currency
        contactId
        language
        state
        number
        dueOn
        issuedOn
        paid
        paidAt
        seller {
          name
        }
        buyer {
          name
        }
        taxPointOn
        deliveryOn
        submittedAt
        kind
        totalFloat
        eetState
        eetInvoice
        paid
      }
      metadata {
        limitValue
        totalPages
        currentPage
        totalCount
      }
    }
  }
`;

export const INVOICES_REPORT_QUERY = gql`
  query InvoicesReport($fulltext: String, $unpaid: Boolean, $contactId: Int, $period: String, $from: String, $to: String, $invoiceKinds: [String!], $recurring: Boolean, $states: [InvoiceStateEnum!], $dueFrom: String, $dueTo: String, $amountFrom: Int, $amountTo: Int) {
  invoicesReport(
    filter: { fulltext: $fulltext, unpaid: $unpaid, contactId: $contactId, period: $period, from: $from, to: $to, invoiceKinds: $invoiceKinds, recurring: $recurring, states: $states, dueFrom: $dueFrom, dueTo: $dueTo, amountFrom: $amountFrom, amountTo: $amountTo }
  ) {
    baseCurrency
    from
    invoicesByCurrency
    invoicesCount
    invoicesSum
    overdueByCurrency
    overdueCount
    overdueSum
    paidByCurrency
    paidCount
    paidSum
    proposalByCurrency
    proposalCount
    proposalSum
    submittedByCurrency
    submittedCount
    submittedSum
    recurringSum
    recurringCount
    recurringByCurrency
    to
  }
}
`;

export const INVOICE_NUMBER_EXISTS_QUERY = gql`
  query InvoiceNumberExists($number: String!) {
    checkInvoiceNumberExistence(number: $number) {
      id
    }
  }
`;

export const INVOICE_QUERY = gql`
  query Invoice($id: ID!) {
    invoice(id: $id) {
      id
      state
      number
      paid
      paidAt
    }
  }
`;

export const INVOICE_UNITS_QUERY = gql`
  query Units {
    units
  }
`;

export const LAST_INVOICE_QUERY = gql`
  query LastInvoice {
    lastInvoice {
      number
    }
  }
`;

export const MERK_SUGGEST_QUERY = gql`
  query MerkSuggestQuery($query: String!, $site: String!) {
    merkSuggestions(query: $query, site: $site) {
      id
      addressCity
      addressPostcode
      addressStreet
      country
      email
      name
      phone
      regNo
      vatNo
      taxNo
      web
    }
  }
`;

export const NEW_SUBSCRIPTION_ORDER_QUERY = gql`
  query NewSubscriptionOrder {
    subscriptionOrders {
      paymentMethods
      planName
      isTrial
      pricelist {
        mini
        premium
      }
      orders {
        id
        state
        createdAt
        planName
        pdfLink
        showOnlinePayLink
        showBankTransferPayLink
        hasDocumentLink
        bankTransferPath
        onlinePaymentPath
      }
    }
  }
`;

export const POSTS_QUERY = gql`
  query Posts($limit: Int, $showOnHomepage: Boolean) {
    posts(limit: { limit: $limit }, showOnHomepage: $showOnHomepage) {
      collection {
        id
        title
        date
        perex
        createdAt
        smallImage
        path
      }
    }
  }
`;

export const PRICELIST_QUERY = gql`
  query Pricelist {
    pricelist {
      paymentMethods
      mini,
      premium
    }
  }
`;

export const PROFESSIONS_QUERY = gql`
  query Professions($page: Int, $perPage: Int, $locale: String!) {
    professions(
      paginate: { page: $page, perPage: $perPage }
      locale: $locale

    ) {
      collection {
        slug
        title
        ctaButtonText
        ctaImage
        indexPerex
      }
      metadata {
        totalPages
        currentPage
        totalCount
      }
    }
  }
`;

export const PROFESSION_QUERY = gql`
  query Profession($slug: String!, $locale: String!, $preview: Boolean) {
    profession(slug: $slug, locale: $locale, preview: $preview) {
      slug
      title
      ctaButtonText
      invoiceLines
      invoiceContent
      examplesParagraph
      examplesParagraphFirstLine
      examplesParagraphSecondLine
      createInvoiceCta
      ctaImage
      backgroundImage
      ctaText
    }
  }
`;

export const SAVED_INVOICE_LINES_QUERY = gql`
  query GetSavedInvoiceLines($page: Int!, $limit: Int!, $fulltext: String, $attribute: String, $direction: String) {
    savedInvoiceLines(
      paginate: { page: $page, perPage: $limit },
      filter: { fulltext: $fulltext }
      sort: { attribute: $attribute, direction: $direction }
    ) {
      collection {
        id
        description
        price
        quantity
        subscriptionId
        unitType
        usedCount
        vatRate
      }
      metadata {
        currentPage
        limitValue
        totalCount
        totalPages
      }
    }
  }
`;

export const SEQUENCE_QUERY = gql`
  query Sequence {
    sequence {
      id
      expenseSequenceFormat
      invoiceSequenceFormat
      taxCorrectionSequenceFormat
      expenseSequenceNumber
      invoiceSequenceNumber
      taxCorrectionSequenceNumber
    }
  }
`;

export const SETTINGS_QUERY = gql`
  query Settings {
   settings {
     id,
     thankYouBody,
     thankYouSubject,
     reminderBody,
     reminderSubject,
     documentBody,
     documentSubject,
     invoiceState,
     invoiceLineDescriptions,
     tableColumns,
     hideGlobalSettings
   }
  }
`;

export const STATISTICS_QUERY = gql`
  query Statistics($kinds: [KindEnum!]!, $period: PeriodEnum!) {
    statistics(kinds: $kinds, period: $period) {
      expenses
      invoices
    }
  }
`;

export const SUBSCRIPTION_COUNTS_QUERY = gql`
  query Subscription {
    subscription {
      contactsCount,
      invoicesCount,
    }
  }
`;

export const THANK_YOU_QUERY = gql`
  query Subscription {
    subscription {
      showThankYouPage,
      surveySubmitted,
      activeUntil,
      lastPeriod {
        paymentType,
        planName
      },
      lastPaidOrder {
        currency,
        amount
      }
    }
  }
`;

export const USERS_QUERY = gql`
  query Users($page: Int, $attribute: String, $direction: String) {
    users(
      paginate: {page: $page}
      sort: {attribute: $attribute, direction: $direction}
    ) {
      collection {
        id
        email
        name
        emailsAccepted
        role
        lastSignInAt
      }
    }
  }
`;

export const USER_QUERY = gql`
  query User($id: ID) {
    user(id: $id) {
      id
      name
      email
      role
      emailsAccepted
    }
  }
`;
